import { Auth0Provider } from "@auth0/auth0-react";
import { RouterProvider } from "@tanstack/react-router";
import { ReactNode } from "react";
import { HelmetDocumentManager } from "./lib/document-manager/HelmetDocumentManager.tsx";
import { getWhiteLabelBrand } from "./lib/white-label-branding/getWhiteLabelBrand.ts";
import { router } from "./router";

type InnerAppProps = {
  children: ReactNode;
};

function InnerApp({ children }: InnerAppProps) {
  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: `${window.location.origin}`,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        organization: getWhiteLabelBrand()?.id
      }}
      onRedirectCallback={(appState) => {
        const routeToPushTo =
          appState && appState.returnTo
            ? appState.returnTo
            : window.location.pathname;

        // redirect the user to the route they originally intended to go to
        router.history.push(routeToPushTo);

        // removes "code" and "state" search parameters applied by auth0 from the url as a reload will cause an error if they are present
        router.state.location.search = {};
      }}
    >
      <HelmetDocumentManager />
      <div data-testid="appRoot">{children}</div>
    </Auth0Provider>
  );
}

function App() {
  return <RouterProvider router={router} InnerWrap={InnerApp} />;
}

export default App;
